<script>
import EventBus from './../EventBus.js'
import get from 'lodash/get'


export default {
  name: 'home-countdown',
  props: {
    countdown_date: {
      type: String,
      default: '',
      required: true,
    }
  },
  components: {
    
  },
  data() {
    return {
      d: '-',
      h: '-',
      m: '-',
      s: '-',
    }
  },
  mounted() {
    console.log('Countdown mounted')
    this.initCounter()

  },
  computed: {
    countDownDate() {
      return this.countdown_date ? new Date(this.countdown_date.replace(' ', 'T')).getTime() : false
    },
  },
  methods: {
    initCounter() {
      if (this.countDownDate) {
        var x = setInterval(() => {
          // Get today's date and time
          const now = new Date().getTime()

          // Find the distance between now and the count down date
          const distance = this.countDownDate - now


          // Time calculations for days, hours, minutes and seconds
          this.d = Math.floor(distance / (1000 * 60 * 60 * 24))
          this.h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
          this.m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
          this.s = Math.floor((distance % (1000 * 60)) / 1000)

          // Display the result in the element with id="demo"
          // document.getElementById("demo").innerHTML = days + "d " + hours + "h "
          // + minutes + "m " + seconds + "s ";

          // If the count down is finished, write some text 
          if (distance < 0) {
            clearInterval(x)
            // document.getElementById("demo").innerHTML = "EXPIRED";
          }
        }, 1000);
      }
    }
  },
}
</script>